const certificateAction = {
  GENERATE: "generate",
  DOWNLOAD: "download",
  REVOKE: "revoke"
};

export default certificateAction;
